<div *ngIf="isLoading | async" class="spinner">
    <mat-spinner [diameter]="50">
    </mat-spinner>
  </div>